// /insights → the first design screen; old bookmarks and the menu icon
// used the flat route before the 21.10 five-screen port.

import { Navigate } from 'react-router-dom'

export default function InsightsIndexRedirect() {
  return <Navigate to="/insights/speech" replace />
}
